import { ChannelType } from "./channel-type";
import { EventType } from "./event-type";

const sendMessage = (event, payload) => {
  if (window != window.parent) {
    window.parent.postMessage(
      {
        type: event.toString(),
        channel: "LV_EVENT",
        payload,
      },
      "*"
    );
  }
};

export const registerApp = (appId) => {
  sendMessage(EventType.REGISTER_APP, { appId });
};

export const registerMenu = (appId, resources) => {
  if (Object.keys(resources).length > 0) {
    try {
      sendMessage(EventType.REGISTER_MENU, {
        appId,
        menu: JSON.stringify(Object.keys(resources)),
      });
    } catch (e) {
      // unable to read menu resources
    }
  }
};

/**
 *
 * wraps the window.addEventListener("message") function to only call the callback when the event type matches LV_EVENTS
 *
 * @param {string} event - The event type to listen for.
 * @param {Function} callback - The function to call when the event is received.
 */
export const listenFor = (event, callback) => {
  // allow the specific handler instance to be removed
  const handlerInst = (message) => {
    if (message.data?.channel == ChannelType.LV_EVENT.toString()) {
      if (message.data?.type == event.toString()) {
        callback(message.data.payload);
      }
    }
  };

  window.addEventListener("message", handlerInst);

  return () => {
    window.removeEventListener("message", handlerInst);
  };
};